export default "__VITE_PUBLIC_ASSET__57736709__"